export default {
    getReminders: (state) => state.reminders,
}
